var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from 'typeorm';
/**
 * CoinTransfer is parsed coin transaction transaction, including
 * both send and receive transactions.
 */
let CoinTransfer = class CoinTransfer {
    id;
    txDigest;
    msafeAddress;
    coinType;
    amount;
    value;
    sender;
    receiver;
    txType; // 0 - send; 1 - receive; 2 - send & receive
    executedAt;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], CoinTransfer.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CoinTransfer.prototype, "txDigest", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], CoinTransfer.prototype, "msafeAddress", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], CoinTransfer.prototype, "coinType", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], CoinTransfer.prototype, "amount", void 0);
__decorate([
    Column('float', { nullable: true }),
    __metadata("design:type", Number)
], CoinTransfer.prototype, "value", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CoinTransfer.prototype, "sender", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CoinTransfer.prototype, "receiver", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], CoinTransfer.prototype, "txType", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CoinTransfer.prototype, "executedAt", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CoinTransfer.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], CoinTransfer.prototype, "createdAt", void 0);
CoinTransfer = __decorate([
    Entity({ name: 'coin_transfer' })
], CoinTransfer);
export { CoinTransfer };
//# sourceMappingURL=module.js.map